export enum IrisIconButtonTypes {
  DEPRESSED = 'depressed',
  RAISED = 'raised',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  DANGER = 'danger',
  NAVIGATION = 'navigation',
  ACTION = 'action'
}
